<template>
  <div class="table-result">
    <table class="table-all">
      <thead>
        <tr>
          <th scope="col" class="specific-th">Nome</th>
          <th scope="col" class="specific-th">Beneficio</th>
          <th scope="col" class="specific-th">Valor Relatado</th>
          <th scope="col" class="specific-th">Valor Previsto</th>
          <th scope="col" class="specific-th">Valor Pago</th>
        </tr>
      </thead>
      <tbody
        v-for="beneficio in beneficiosWithValue"
        :key="beneficio.id + ' ' + beneficio.codeUser"
      >
        <tr>
          <td data-label="nome" class="specific-td">{{beneficio.nomeFuncionario}}</td>
          <td data-label="beneficio" class="specific-td">{{beneficio.beneficio}}</td>
          <td data-label="valor relatado" class="specific-td">
            <money
              v-model="beneficio.valor"
              v-bind="money"
              class="mask-input-invisible-value-pay rigth-especific margin-top-specific"
              disabled
            />
          </td>
          <td data-label="valor previsto" class="specific-td">
            <div v-if="beneficio.valuePermited == 0">
              <money
                v-model="beneficio.valor"
                v-bind="money"
                class="mask-input-invisible-value-pay rigth-especific margin-top-specific"
                disabled
              />
            </div>
            <div v-else>
              <money
                v-model="beneficio.valuePermited"
                v-bind="money"
                class="mask-input-invisible-value-pay rigth-especific margin-top-specific"
                disabled
              />
            </div>
          </td>
          <td data-label="valor pago" class="specific-td">
            <money
              v-model="beneficio.valorPago"
              v-bind="money"
              class="mask-input-invisible-value-pay rigth-especific margin-top-specific"
              disabled
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Money } from "v-money";
export default {
  name: "TableResult",
  props: ["beneficiosWithValue"],
  components: { Money },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  }
};
</script>

<style scoped src="./table-result.css" ></style>
